import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const ContentCont = styled.div`
  display: flex;
  flex-flow: column nowrap;
  ${({ theme }: IThemeProvider) => `
    padding:
      ${theme.layout.spacing.decy}
      ${theme.layout.spacing.decy}
      ${theme.layout.spacing.giga};
  `}
`;

export const ContentNote = styled(BodyBoldS)`
  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.mikro};
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const ContentQuestion = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
